import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgResetFormat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.32867 3.33301V5.62376H6.82837V14.7868H9.28275V5.62376H13.7824V3.33301H2.32867ZM11.9266 10.9158L10.8659 11.9764L9.71715 13.1252C9.32662 13.5157 9.32662 14.1489 9.71715 14.5394L10.7066 15.5289C11.7883 16.6106 13.4905 16.6936 14.6674 15.7779C14.7652 15.7018 14.8594 15.6188 14.9493 15.5289L15.7445 14.7337L17.8477 12.6304C18.2383 12.2399 18.2383 11.6068 17.8477 11.2162L15.444 8.81252C15.0535 8.42199 14.4203 8.42199 14.0298 8.81252L11.9266 10.9158ZM11.9266 13.0371L13.5897 14.7002C13.0145 15.0397 12.2614 14.9624 11.7673 14.4682L11.1314 13.8323L11.9266 13.0371ZM12.9872 11.9764L14.6838 13.673L16.4335 11.9233L14.7369 10.2267L12.9872 11.9764Z",
		fill: "currentColor"
	})
});
export default SvgResetFormat;
